function apiConfig () {
  return (
    {
      apiRoot: process.env.REACT_APP_BASE_API_URL,
    }
  )
}


module.exports = {apiConfig}

